<template>
<!-- 联系我们 -->
    <div>
        <div class="topImg">
            <span>联系我们</span>
        </div>
        <div class="contacUs">
            <div class="companyAddress">
                <div class="cus">联系我们</div>
                <div class="addressAndMap">
                    <div class="address">
                        <div class="areaAndphone" v-for="(item,index) in companyInfo" :key="index">
                            <div class="area">
                                <img loading="lazy" src="@/assets/img/contactUs/dizhi.png">
                                <span><a>地址：</a>{{item.province}} {{item.city}} {{item.district}} {{item.townOrStreet}} {{item.address}} <strong>（{{item.typeDescr}}）</strong></span>
                            </div>
                            <div class="phone">
                                <img loading="lazy" src="@/assets/img/contactUs/lianxiwomen_dianhua.png">
                                <span><a>电话：</a>+86 {{item.telPhone}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="mapDiv">
                        <div class="wow zoomIn map" id="s-map" data-wow-delay=".1s">
                            <div id="map" class="bm-view" ref="mymap"></div>
                        </div>
                        <div class="area">
                            <span v-for="(item,index) in companyInfo" :key="index" @click="createMap(item)" :class="cityIndex == item.id ? 'areaBackColor':''">{{item.city}}{{item.typeDescr}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="userInfo">
                <div class="companyEmail">
                    <div class="emailOne">
                        <img loading="lazy" src="@/assets/img/contactUs/lianxiwomen_youjian.png" alt="">
                        <span>
                            <strong>企业合作邮箱：2629387311@qq.com</strong>
                        </span>
                    </div>
                    <div class="emailTwo">
                        <img loading="lazy" src="@/assets/img/contactUs/lianxiwomen_youjian.png" alt="">
                        <span>
                            <strong>媒体合作邮箱：1851497609@qq.com</strong>
                        </span>
                    </div>
                </div>
                <div class="messageUs">给我们留言</div>
                
                <el-form :model="subObj" :rules="rules" ref="subObj" :inline="true" class="subObj">
                    <div class="npe">
                        <el-form-item label="姓名：" class="labelWidth" prop="userName">
                            <el-input class="input" placeholder="请输入姓名" v-model="subObj.userName"></el-input> 
                        </el-form-item>
                        <el-form-item label="电话：" class="labelWidth" prop="userPhone">
                            <el-input class="input" placeholder="请输入电话" v-model="subObj.userPhone"></el-input>
                        </el-form-item>
                        <el-form-item label="邮箱：" class="labelWidth" prop="userEmail">
                            <el-input class="input" placeholder="请输入邮箱" v-model="subObj.userEmail"></el-input>
                        </el-form-item>
                    </div>
                    <el-form-item label="内容：" class="labelWidth desc" prop="userDesc">
                        <el-input
                            class="textarea"
                            type="textarea"
                            :autosize="{ minRows: 7, maxRows: 14}"
                            placeholder="请输入内容"
                            v-model="subObj.userDesc">
                        </el-input>
                    </el-form-item>
                </el-form>
                
                <div class="submitBut">
                    <span class="submitbt" @click="submit('subObj')"> 提交 </span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapMutations } from 'vuex'
// setSaveContactUs 留言信息
import {setSaveContactUs,getCompanyInfo} from '@/api'
let validateEmail = (rule, value, callback) => {
    if (!value) {
        return callback(new Error("邮箱不能为空！"));
    }
    else {
        // eslint-disable-next-line no-useless-escape
        const reg=/^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/
        if(reg.test(value)){
            callback();
        }else {
            return callback(new Error("邮箱格式不正确！"));
        } 
    }
};
var checkPhone = (rule, value, callback) => {
    if (!value) {
        return callback(new Error('手机号不能为空'));
    } else {
        //验证手机号和区号
        const reg =  /\d{3}-\d{8}|\d{4}-\d{7}|^1((34[0-8])|(8\d{2})|(([35][0-35-9]|4[579]|66|7[35678]|9[1389])\d{1}))\d{7}$/
        if (reg.test(value)) {
            callback();
        } else {
            return callback(new Error('请输入正确的联系电话'));
        }
    }
};
export default {
    name: 'YinshiOffcialwebsiteContactUs',
    data() {
        return {
            // 当前地区的下标
            cityIndex:0,
            // 要提交的内容
            subObj:{
                userName:'',
                userPhone:'',
                userEmail:'',
                userDesc:''
            },
            // 验证
            rules: {
                userName: [{ required: true, message: '请输入您的姓名', trigger: 'blur' }],
                userEmail: [{ required: true, validator: validateEmail, trigger: "blur" }],
                userPhone: [{ required: true, validator: checkPhone, trigger: "blur" }],
                userDesc:[{ required: true, message: '请输入您想说的话', trigger: 'blur' }]
            },
            // 公司信息
            companyInfo:[],
        };
    },

    mounted() {
        // new this.$WOW.WOW().init()
        
    },

    methods: {
        ...mapMutations(['GoTop']),
        // 加载地图
        createMap(obj){
            // 当前点击按钮的下标
            this.cityIndex = obj.id
            // 地图实例
            var BMap = window.BMap;
            var map = new BMap.Map("map"); // 创建地图实例
            var point = new BMap.Point(obj.longitude,obj.latitude); // 创建点坐标
            map.centerAndZoom(point, 18); // 初始化地图，设置中心点坐标和地图级别
            map.enableScrollWheelZoom(false); //开启鼠标滚轮缩放
            // 添加城市列表控件
            map.addControl(new BMap.CityListControl());
            var marker = new BMap.Marker(point); // 创建标注
            
            map.addOverlay(marker); // 将标注添加到地图中
            var opts = {
                width: 80, // 信息窗口宽度
                height: 30, // 信息窗口高度
                title: obj.name // 信息窗口标题
            };
            var infoWindow = new BMap.InfoWindow(
                obj.province+' '+obj.city+' '+obj.district+' '+obj.townOrStreet+' '+obj.address,
                opts
            ); // 创建信息窗口对象
            map.openInfoWindow(infoWindow, map.getCenter()); // 打开信息窗口
        },
        // 查询公司信息
        async selectCompanyInfo(){
            let res = await getCompanyInfo();
            this.companyInfo = res.data
            this.$nextTick(()=> {
                this.createMap(this.companyInfo[0])
            })
        },
        // 提交
        async submit(subObj){  
            this.$refs[subObj].validate(async (valid) => {
                if (valid) {
                    let res = await setSaveContactUs({
                        content:this.subObj.userDesc,
                        email:this.subObj.userEmail,
                        name:this.subObj.userName,
                        phone:this.subObj.userPhone,
                    })
                    if(res.code == 200){
                        this.$message({ message:'留言成功！', type: 'success' });
                    }else{
                        this.$message({message: res.data+'！',type: 'error'});
                    }
                } else {
                    return false;
                }
            });
        },
    },    
    created(){
        this.$store.state.currentRouter = this.$route.path  //获取当前页面路由
        this.GoTop()
        this.selectCompanyInfo()
        
    }
};
</script>

<style lang="scss">
    .contacUs{
        .BMap_bubble_title{
            font-size: 16px !important;
        }
        .BMap_bubble_content{
            font-size: 13px !important;
        }
        .el-form-item__label{
            font-size: 16px;
        }
        .subObj{
            margin-top: 40px;
            .npe{
                display: flex;
                justify-content: space-between;
                input{
                    width: 300px;
                }
            }
            .desc{
                width: 100%;
                .el-form-item__content{
                    width: 100%;
                }
            }
        }
    }

</style>
<style lang="scss" scoped>   
    // 顶部图片
    .topImg{
        background: url(../assets/img/contactUs/contactUsImg.jpg);
        display: flex;
        justify-content: flex-start;
        span{
            margin-left: 100px;
        }
    }
    // 公司地址信息
    .contacUs{
        padding:70px 240px;
        .companyAddress{
            padding-bottom:30px ;
            border-bottom: 1px dashed #e0e0e0;
            // 联系我们title
            .cus{   
                width: 87px;
                height: 36px;
                background: #7492d7;
                border-radius: 5px;
                font-size: 16px;
                font-family: Microsoft YaHei, Microsoft YaHei-Bold;
                font-weight: 700;
                color: #ffffff;
                display: flex;
                justify-content: center;
                align-items: center;
            }
            // 地址和地图
            .addressAndMap{
                margin-top: 20px;
                display: flex;
                justify-content: space-between;
                // 所有地址
                .address{
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    // 单个
                    .areaAndphone{
                        .area,.phone{
                            display: flex;
                            margin-top: 20px;
                            span{
                                margin-left: 20px;
                                font-size: 16px;
                                font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                                font-weight: 400;
                                color: #666666;
                                a{
                                    display: inline-block;
                                    text-align: right;
                                    width: 50px;
                                    font-size: 16px;
                                    color: #666666;

                                }
                                strong{
                                    font-weight: 700;
                                }
                            }
                        }
                        .area img{
                            width: 18px;
                            height: 21px;
                        }
                        .phone img{
                            width: 15px;
                            height: 15px;
                            margin-top: 4px;
                        }
                    }
                }
                // 地图
                .mapDiv{
                    margin-top: -30px;
                    .map{
                        width: 690px;
                        height: 400px;
                        .bm-view{
                            width: 100%;
                            height: 100%;
                        }
                    }
                    // 地区
                    .area{
                        display: flex;
                        justify-content: space-between;
                        span{
                            width: 100%;
                            padding: 12px 0px;
                            padding-bottom: 14px;
                            text-align: center;
                            background: #f2f2f2;
                            font-size: 16px;
                            font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                            font-weight: 400;
                            color: #666666;
                            transition: .3s;
                            cursor: pointer;
                            border-right:1px solid #e9e9e9;
                        }
                        span:hover{
                            background:#7a99e1d0 !important;
                            color: rgb(244, 244, 244) !important;
                        }
                    }
                    // 背景颜色
                    .areaBackColor{
                        background: #7492d7 !important;
                        color: #fff !important;
                    }
                }
            }
        }
        // 用户填写信息
        .userInfo{
            margin-top: 30px;
            // 公司邮箱
            .companyEmail{
                display: flex;
                .emailOne,.emailTwo{
                    display: flex;
                    align-items: center;
                    img{
                        width: 20px;
                        height: 15px;
                    }
                    span{
                        margin-left: 20px;
                        font-size: 16px;
                        font-weight: 400;
                        color: #666666;
                        margin-top: 0.4px;
                        strong{
                            font-size: 16px;
                            font-weight: 400;
                            color: #666666;
                        }
                    }

                }
                .emailTwo{
                    margin-left: 60px;
                }
            }
            // 给我们留言
            .messageUs{
                margin-top: 70px;
                width: 111px;
                height: 36px;
                background: #7492d7;
                border-radius: 5px;
                display: flex;
                justify-content: center;
                align-items: center;
                color:#fff;
                font-weight: 700;
                font-size: 18px;
            }
            // 用户联系方式
            .userInfo{
                margin-top: 50px;
                display: flex;
                justify-content: space-between;
                .userName,.userPhone,.userEmail{
                    display: flex;
                    align-items: center;
                    .input{
                        margin-left: 5px;
                        width: 300px;
                    }
                } 

            }
            .userInfo,.userContent span{
                font-size: 18px;
                font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                font-weight: 400;
                white-space: nowrap;
                color: #666666;
            }
            // 内容 留言
            .userContent{
                margin-top: 30px;
                .textarea{
                    margin-top: 20px;
                }
            }
            // 提交按钮
            .submitBut{
                margin-top: 35px;
                .submitbt{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 133px;
                    height: 40px;
                    background: #7492d7;
                    border-radius: 20px;
                    font-size: 16px;
                    font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                    font-weight: 400;
                    text-align: center;
                    color: #ffffff;
                    cursor: pointer;
                    transition:.3s;
                }
                .submitbt:hover{
                    background: #7492d7b9;
                }
            }
        }
    }
/* 深色模式 */
@media (prefers-color-scheme: dark) {
    body { background: #333; color: white; }
}
/* 浅色模式 */
@media (prefers-color-scheme: light) {
    body { background: white; color: #333; }
}
</style>